import {ParticipantMember} from './ParticipantMember';

export class Entry {
    entry_id: number;
    group_id: number;
    group_name: string;
    entry_name: string;
    timezone: string;
    ordinal: number;
    starts: number;
    ends: number;
    current: number;
    next: number;
    frequency_id: number;
    frequency_name: string;
    days_of_week: ({ name: string; id: number })[];
    participants: ParticipantMember[];
}
